import type { RenameCandidate, SchemaDiffField } from '@cli-types/core-engine/snapshots.js'
import { detectRenames } from './detect-renames.js'

export function detectRenameCandidates(
  removed: SchemaDiffField[],
  added: SchemaDiffField[]
): RenameCandidate[] {
  return detectRenames(
    removed,
    added,
    (entry) => entry.name,
    (before, after) => after.type === before.type
  )
}
